import styled from "styled-components";

export const Header = styled.h2`
color: var(--fixit)

`

export const Container = styled.div`
  color: var(--dark-gray);
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 1rem 0;
`

export const Content = styled.div`
  color: var(--dark-gray);
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
`
